import createDOMPurify from 'dompurify'

const DOMPurify: ReturnType<typeof createDOMPurify> = createDOMPurify(window)

export default {
  mounted(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value)
  },
  updated(el, binding) {
    el.innerHTML = DOMPurify.sanitize(binding.value)
  },
}
